import { createContext } from 'react';

/**
 * Shared state for the native bottom-nav tab stacks. Produced by `MobileTabsProvider`; consumed by
 * `MobileTabPanes` (to render the kept-alive panes) and `BottomNav` (to restore a tab's last
 * position on tap and to highlight the active tab) via `useContext`. Null outside a provider
 * (desktop / web), so callers can no-op without crashing.
 *
 * @type {React.Context<{
 *   panes: Array<{tabId: string, location: Object}>,
 *   activeTabId: string|null,
 *   getTabLocation: (tabId: string) => (Object|null),
 *   setPendingTabId: (tabId: string|null) => void,
 * }|null>}
 */
const MobileTabsContext = createContext(null);

export default MobileTabsContext;
